var _excluded = ["above", "below", "print", "screen"],
  _excluded2 = ["children", "above", "below", "screen", "print", "screenReader"];
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
import React, { Children } from "react";
import styled, { css } from "styled-components";
import { breakpoint } from "../breakpoint";
import { breakpointPropTypes } from "../utils"; // eslint-disable-next-line @typescript-eslint/no-unused-vars
var HiddenWrapper = styled(function (_ref) {
  var above = _ref.above,
    below = _ref.below,
    print = _ref.print,
    screen = _ref.screen,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("div", rest);
}).attrs({
  "data-mesh-component": "HIDDEN"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n"])), function (_ref2) {
  var below = _ref2.below;
  return below && css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      // When we are below the 'below' breakpoint:\n      ", "\n    "])), breakpoint("xs", below)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n          display: none;\n        "]))));
}, function (_ref3) {
  var above = _ref3.above;
  return above && css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n      // When we are above the 'above' breakpoint:\n      ", "\n    "])), breakpoint(above)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n          display: none;\n        "]))));
}, function (_ref4) {
  var print = _ref4.print;
  return print && "\n      @media print {\n        display: none;\n      }\n  ";
}, function (_ref5) {
  var screen = _ref5.screen;
  return screen && "\n      // Keep focus and active visuals on interactive elements\n      > :not(:focus):not(:active) {\n        position: absolute !important;\n        height: 1px;\n        width: 1px;\n        overflow: hidden;\n        clip: rect(1px, 1px, 1px, 1px);\n        white-space: nowrap;\n      }\n    ";
});
export var Hidden = function Hidden(_ref6) {
  var children = _ref6.children,
    above = _ref6.above,
    below = _ref6.below,
    _ref6$screen = _ref6.screen,
    screen = _ref6$screen === void 0 ? false : _ref6$screen,
    _ref6$print = _ref6.print,
    print = _ref6$print === void 0 ? false : _ref6$print,
    _ref6$screenReader = _ref6.screenReader,
    screenReader = _ref6$screenReader === void 0 ? false : _ref6$screenReader,
    otherProps = _objectWithoutProperties(_ref6, _excluded2);
  return /*#__PURE__*/React.createElement(HiddenWrapper, _extends({
    above: above,
    below: below,
    print: print,
    screen: screen,
    "aria-hidden": screenReader
  }, otherProps), Children.map(children, function (child) {
    if ( /*#__PURE__*/React.isValidElement(child)) {
      return child;
    } else if (typeof child === "string") {
      return /*#__PURE__*/React.createElement("span", null, child);
    }
    return null;
  }));
};
Hidden.displayName = "Hidden";